<template>
  <v-container grid-list-xl fluid v-if="freeSamplePacks">
    <v-layout row wrap>
      <v-flex xs8 offset-xs2>
        <v-btn fab fixed bottom right large color="primary" @click="showModal()" class="link">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-container grid-list-xl fluid>
            <v-data-iterator :items="freeSamplePacks" content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props" xs12>
                <v-list dense>
                  <v-list-tile>
                    <v-list-tile-content>{{ props.item.name }} - {{ props.item.group.type }} {{ props.item.group.name }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">
                      <v-btn small color="primary">Details</v-btn>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-flex>
            </v-data-iterator>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="isModalVisible">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Add Sample Pack</v-card-title>
        <v-card-text>
          <v-container grid-list-xl fluid>
            <h3 class="headline">Add Free Sample Pack</h3>
            <v-text-field v-model="freeSamplePack.name" label="Name"></v-text-field>
            <v-select v-model="freeSamplePack.group" :items="fabricGroups" item-text="name" item-value="_id" @click="getFabrics(freeSamplePack.group)" label="Group"></v-select>
            <v-select v-model="fabricID" @change="getColors(fabricID)" label="Fabric" :items="fabrics" item-text="name" item-value="_id"></v-select>
          </v-container>

          <v-divider></v-divider>

          <v-container grid-list-xl fluid>
            <h3 class="headline">Colours</h3>
            <v-select v-model="colorID" :items="colors" item-text="name" item-value="_id" label="Colors"></v-select>
            <v-btn small color="primary" @click="addColorToPack()" v-if="colorID">Add Color to Pack</v-btn>

            <!-- Replace with data iterator -->
            <!-- <li v-for="(color, index) in freeSamplePack.colors" :key="index">{{ color.fabric.name }} - {{ color.name }} <a class="link" @click="removeColor(index)">Remove</a></li> -->
          </v-container>

          <v-divider></v-divider>

          <v-container grid-list-xl fluid>
            <h3 class="headline">Tags</h3>
            <v-select v-model="tagID" :items="tags" item-text="name" item-value="_id" label="Tags"></v-select>
            <v-btn small color="primary" @click="addTagToPack()" v-if="tagID">Add Tag to Pack</v-btn>
          </v-container>

          <li v-for="(tag, index) in freeSamplePack.tags" :key="index">{{ tag.label }} <a class="link" @click="removeTag(index)">Remove</a></li>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveFreeSamplePack()">Save Free Sample Pack</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import FreeSampleService from '@/services/FreeSampleService.js'
import FabricGroupService from '@/services/FabricGroupService.js'
import FabricService from '@/services/FabricService.js'
import ColorService from '@/services/ColorService.js'
import TagService from '@/services/TagService.js'
export default {
  data () {
    return {
      freeSamplePacks: null,
      isModalVisible: false,
      freeSamplePack: {
        name: null,
        group: null,
        colors: [],
        tags: []
      },
      fabricGroups: null,
      fabrics: [],
      fabricID: null,
      colorID: null,
      tagID: null,
      colors: [],
      tags: null
    }
  },
  mounted () {
    this.getFreSamplePacks()
    this.getFabricGroups()
    this.getTags()
  },
  methods: {
    async getFreSamplePacks () {
      const response = await FreeSampleService.getFreeSamplePacks()
      this.freeSamplePacks = response.data.freeSamplePacks
    },

    async getFabricGroups () {
      const response = await FabricGroupService.getFabricGroups()
      this.fabricGroups = response.data.fabricGroup
    },

    async getFabrics (groupID) {
      const response = await FabricService.getFabricsByGroup(groupID)
      this.fabrics = response.data.fabrics
    },

    async getColors (fabricID) {
      const response = await ColorService.getColorsByFabric(fabricID)
      this.colors = response.data.colors
    },

    async getTags () {
      const response = await TagService.getTags()
      this.tags = response.data.tags
    },

    async saveFreeSamplePack () {
      // Need to extract the IDs from colours and tags
      var colorIDs = []
      var tagIDs = []
      this.freeSamplePack.colors.forEach(function (color) {
        colorIDs.push(color._id)
      })
      this.freeSamplePack.tags.forEach(function (tag) {
        tagIDs.push(tag._id)
      })
      var newFreeSamplePack = this.freeSamplePack
      newFreeSamplePack.colors = colorIDs
      newFreeSamplePack.tags = tagIDs
      await FreeSampleService.createFreeSamplePack(newFreeSamplePack)
    },

    async addColorToPack () {
      const response = await ColorService.getColor(this.colorID)
      this.freeSamplePack.colors.push(response.data)
    },

    async addTagToPack () {
      const response = await TagService.getTag(this.tagID)
      this.freeSamplePack.tags.push(response.data)
    },

    showModal () {
      this.isModalVisible = true
    },

    closeModal () {
      this.isModalVisible = false
    },

    removeColor (index) {
      this.freeSamplePack.colors.splice(index, 1)
    },

    removeTag (index) {
      this.freeSamplePack.tags.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/freeSamplePacks/FreeSamplePacks.vue